import { use_slice_ui } from '@/hooks/store/use_slices';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { useTranslation } from 'react-i18next';

interface PROPS {
  children: React.ReactNode;
  type: string;
}

export function S_TAB__user_wrapper({ children, type }: PROPS) {
  const { page_settings_user_current_tab } = use_slice_ui(['page_settings_user_current_tab']);

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_USER);

  if (page_settings_user_current_tab != type) return <></>;

  return (
    <div className={`size-full bg-component  text-page-foreground flex flex-col text-left`}>
      <div className={`pb-2  ${md('overflow-auto px-2 bg-component', 'px-8')}`}>{children}</div>
    </div>
  );
}
